<template>
  <div class="form-group">
    <slot name="top">
      <div v-if="showGender" class="row form-group">
        <w-radio-list
          title=""
          class="col-12"
          :model="model.gender"
          :values="gender"
          :disabled="checkDisabled('gender')"
          :show-error="checkHiddenError('gender')"
        />
      </div>
    </slot>

    <div v-if="showNames" class="row form-group">
      <w-input
        class="col-6"
        :model="model.firstName"
        :disabled="checkDisabled('firstName')"
        :show-error="checkHiddenError('firstName')"
      />

      <w-input
        class="col-6"
        :model="model.lastName"
        :disabled="checkDisabled('lastName')"
        :show-error="checkHiddenError('lastName')"
      />
    </div>

    <slot />

    <address-row v-if="hasAddress" :model="model.address" :title="addressTitle" :disabled="disabled" />
  </div>
</template>

<script>
import { componentMixin } from '@/mixins/document/component';
import { GENDER } from '@/utils/constants';
import AddressRow from './Address';

// @vuese
// Komponent osoby
// @Group formComponents
export default {
  components: { AddressRow },
  mixins: [componentMixin],
  props: {
    // @vuese
    // Alternatywny tytuł adresu
    addressTitle: { type: String, required: false },

    // @vuese
    // Czy wyświetlić adres
    hasAddress: { type: Boolean, default: true }
  },
  data() {
    return {
      gender: GENDER
    };
  },
  computed: {
    showGender() {
      return !this.model.pesel && this.model.gender && !this.model.gender.$disabled;
    },

    showNames() {
      return !this.model.firstName.$disabled || !this.model.lastName.$disabled;
    }
  }
};
</script>
